import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetSnowflake: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2v20m0-4l-4-4m4 4l4-4m-4-12l-4 4m4-4l4 4M2 12h20m-4 0l-4-4m4 4l-4 4M6 12l4-4m-4 4l4 4" />
      </svg>
    </div>
  );
};

export default WidgetSnowflake;
